export class ReorderOptionDto{
    constructor(id : number, name: string) {
        this.id = id;
        this.name = name;
    }
    id: number;
    name: string;
}


// WEBPACK FOOTER //
// ./ClientApp/dto/ReorderOptionDto.ts